import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const getAndroidSystemLogAPI = async (device_id, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/command/ora-upload-android-logs-send`,
    method: "POST",
    data: {
      device_id,
      execute_type: "upload_android_logs"
    }
  });
  successHandling(t, successfulText);
  return res.data;
};
